import { useT } from "src/internationalization";
import { AppDataType } from "src/types/typedValue";

export const useListMetaData = (): {
  code: string;
  name: string;
  dataType: AppDataType;
  header?: string;
}[] => {
  const t = useT();

  return [
    { code: "id", name: "id", dataType: "string" },
    {
      name: "adminStatus.lastModification",
      code: "lastModification",
      dataType: "date",
      header: t("page.blacklists.table.header.date.updated"),
    },
    //TODO To be removed when add disabled field
    {
      name: "status",
      code: "status",
      dataType: "string",
      header: t("page.blacklists.table.header.status"),
    },
    {
      name: "origin",
      code: "origin",
      dataType: "string",
      header: t("page.blacklists.table.header.origin"),
    },
    {
      name: "sourceCaseType.code",
      dataType: "string",
      code: "sourceCaseType",
      header: t("page.blacklists.table.header.caseType"),
    },
  ];
};
